import React, { useState } from 'react';
import {
  Box,
  Button,
  Container,
  CssBaseline,
  TextField,
  FormControlLabel,
  Checkbox,
  Typography,
  InputAdornment,
  IconButton,
  Link as MUILink,
  Avatar,
  Fade,
  Paper,
  CircularProgress,
} from '@mui/material';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Visibility, VisibilityOff, Lock } from '@mui/icons-material';
import { useNavigate, Link } from 'react-router-dom';
import { BASE_URL, RAZORPAY_URL } from './../Api/ApiUrls';
import property_pincode_new from "./../../../src/Images/property_pincode_new.png";
import SuccessAlert from '../Users/Alertpage/SuccessAlert/SuccessAlert';

const RegisterPage = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [usertype, setUsertype] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  // const [rememberMe, setRememberMe] = useState(false);
  const [acceptTerms, setAcceptTerms] = useState(false);
  const [error, setError] = useState('');
  const [referred_by, setReferred] = useState('');
  const [isLoading, setIsLoading] = useState(false);
const [showSuccess, setShowSuccess] = useState(false);
  const navigate = useNavigate();

const handleSubmit = async (e) => {
  e.preventDefault();

  console.log("👉 Form Submit Triggered");

  setError('');
  setIsLoading(true);

  // ✅ Validate Terms
  if (!acceptTerms) {
    console.warn("⚠️ Terms not accepted");
    setError("Please accept Terms & Conditions");
    setIsLoading(false);
    return;
  }

  // ✅ Validate Fields
  if (!name || !email || !phone || !password || !usertype) {
    console.warn("⚠️ Missing fields", {
      name,
      email,
      mobile_no: phone,
      password,
      usertype,
    });
    setError('All fields are required');
    setIsLoading(false);
    return;
  }

  try {
    const payload = { email, mobile_no: phone };

    console.log("📤 Sending OTP Request:");
    console.log(JSON.stringify(payload, null, 2));

    // 👉 Call OTP API
    const res = await fetch(`${BASE_URL}/reg-send-otp/`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });

    console.log("📥 Raw Response Status:", res.status);

    const data = await res.json();

    console.log("📥 Response Data:");
    console.log(JSON.stringify(data, null, 2));

    if (!res.ok) {
      console.error("❌ API Error:", data);
      setError(data.error || 'Failed to send OTP');
      setIsLoading(false);
      return;
    }

    console.log("✅ OTP Sent Successfully");

    // 👉 Navigate to verify page
    const navData = {
      name,
      email,
      phone,
      password,
      usertype,
      referred_by,
    };

    console.log("🚀 Navigating with Data:");
    console.log(JSON.stringify(navData, null, 2));

    navigate('/verify-email', {
      state: navData,
    });

  } catch (err) {
    console.error("🔥 Exception Occurred:", err);
    setError('Something went wrong');
  } finally {
    console.log("🔄 Loading Finished");
    setIsLoading(false);
  }
};

  const handleSuccessClose = () => {
  setShowSuccess(false);
  navigate('/');
};

  return (
 <>
      {/* ✅ Render SuccessAlert on top when registration succeeds */}
      {showSuccess && (
        <SuccessAlert
          message="Registration successful! Welcome aboard."
          onClose={handleSuccessClose}
        />
      )}
 
      <Fade in timeout={700}>
        <Box
          sx={{
            minHeight: '100vh',
            background: 'linear-gradient(135deg, #0d0d25, #000)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            py: 6,
          }}
        >
          <Container maxWidth="xs">
            <CssBaseline />
            <Paper
              elevation={10}
              sx={{
                p: 4,
                borderRadius: 4,
                background: 'rgba(255, 255, 255, 0.02)',
                border: '1px solid rgba(255, 215, 0, 0.3)',
                backdropFilter: 'blur(10px)',
                textAlign: 'center',
                color: '#fff',
              }}
            >
              <Avatar
                src={property_pincode_new}
                sx={{
                  width: 100,
                  height: 100,
                  mb: 2,
                  mx: 'auto',
                  boxShadow: '0 0 10px #ffd700',
                  objectFit: 'cover',
                }}
              />
 
              <Typography variant="h5" sx={{ color: '#f7e896', fontWeight: 600, mb: 2 }}>
                Create an Account
              </Typography>
 
              {error && (
                <Typography color="error" sx={{ fontSize: 14, mb: 2 }}>
                  {error}
                </Typography>
              )}
 
              <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
 
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  label="Full Name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  InputProps={{
                    sx: {
                      backgroundColor: 'rgba(255,255,255,0.05)',
                      borderRadius: 2,
                      color: 'white',
                    },
                  }}
                  InputLabelProps={{ style: { color: '#ccc' } }}
                />
 
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  label="Email Address"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value.toLowerCase())}
                  InputProps={{
                    sx: {
                      backgroundColor: 'rgba(255,255,255,0.05)',
                      borderRadius: 2,
                      color: 'white',
                    },
                  }}
                  InputLabelProps={{ style: { color: '#ccc' } }}
                />
 
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  label="Phone Number"
                  type="tel"
                  value={phone}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, '');
                    if (value.length <= 10) {
                      setPhone(value);
                    }
                  }}
                  inputProps={{ maxLength: 10 }}
                  error={phone.length > 0 && phone.length !== 10}
                  helperText={
                    phone.length > 0 && phone.length !== 10
                      ? 'Mobile number must be 10 digits'
                      : ''
                  }
                  InputProps={{
                    sx: {
                      backgroundColor: 'rgba(255,255,255,0.05)',
                      borderRadius: 2,
                      color: 'white',
                    },
                  }}
                  InputLabelProps={{ style: { color: '#ccc' } }}
                />
              <FormControl
  fullWidth
  margin="normal"
  required
  sx={{
    '& .MuiOutlinedInput-root': {
      backgroundColor: 'rgba(255,255,255,0.05)',
      borderRadius: 2,
      color: 'white',
    },
    '& .MuiSvgIcon-root': {
      color: '#f7e896', // 👈 dropdown icon color
    },
  }}
>
  <InputLabel sx={{ color: '#ccc' }}>Role</InputLabel>

  <Select
    value={usertype}
    onChange={(e) => setUsertype(e.target.value)}
    label="Role"
    IconComponent={ExpandMoreIcon} // 👈 force arrow icon
    MenuProps={{
      PaperProps: {
        sx: {
          backgroundColor: '#1a1a2e',
          color: 'white',
        },
      },
    }}
  >
    <MenuItem value="Buyer">Buyer</MenuItem>
    <MenuItem value="Tenant">Tenant</MenuItem>
    <MenuItem value="Individual Owner/Builder">Individual Owner/Builder</MenuItem>
    <MenuItem value="Landlord">Landlord</MenuItem>
    <MenuItem value="Agent">Agent</MenuItem>
    <MenuItem value="Bank Auction">Bank Auction</MenuItem>
  </Select>
</FormControl>
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  label="Password"
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  InputProps={{
                    sx: {
                      backgroundColor: 'rgba(255,255,255,0.05)',
                      borderRadius: 2,
                      color: 'white',
                    },
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setShowPassword(!showPassword)}
                          edge="end"
                          sx={{ color: 'rgb(252, 232, 118)' }}
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  InputLabelProps={{ style: { color: '#ccc' } }}
                />
 
                <TextField
                  margin="normal"
                  fullWidth
                  label="Only enter if you have referral number"
                  value={referred_by}
                  onChange={(e) => setReferred(e.target.value)}
                  InputProps={{
                    sx: {
                      backgroundColor: 'rgba(255,255,255,0.05)',
                      borderRadius: 2,
                      color: 'white',
                    },
                  }}
                  InputLabelProps={{ style: { color: '#ccc' } }}
                />
 
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={acceptTerms}
                      onChange={(e) => setAcceptTerms(e.target.checked)}
                      sx={{ color: '#f7e896' }}
                    />
                  }
                  label={
                    <Typography variant="body2" sx={{ color: '#ccc' }}>
                      I accept{" "}
                      <MUILink
                        component={Link}
                        to="/termsandconditions"
                        sx={{ color: '#f7e896', textDecoration: 'underline' }}
                      >
                        Terms & Conditions
                      </MUILink>
                    </Typography>
                  }
                />
 
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  startIcon={
                    isLoading
                      ? <CircularProgress size={20} color="inherit" />
                      : <Lock />
                  }
                  disabled={isLoading || !acceptTerms}
                  sx={{
                    mt: 3,
                    mb: 2,
                    background: 'linear-gradient(135deg, #f1e57c, #e6ce45)',
                    color: '#000',
                    fontWeight: 'bold',
                    '&:hover': {
                      background: 'linear-gradient(135deg, #ffe85c, #f0d53e)',
                    },
                  }}
                >
                  {isLoading ? 'Registering...' : 'Register'}
                </Button>
 
                <Box display="flex" justifyContent="space-between">
                  <MUILink
                    component={Link}
                    to="/"
                    variant="body2"
                    sx={{ color: 'rgb(250, 231, 121)' }}
                  >
                    Already have an account? Login
                  </MUILink>
                </Box>
 
              </Box>
            </Paper>
          </Container>
        </Box>
      </Fade>
    </>
  );
};
 
export default RegisterPage;